import {
  FormControl,
  FormLabel,
  Heading,
  Select,
  VStack,
} from '@frontend/legacy-components';

import {
  WORKFLOW_STEP_STATUS as CUSTOM_WORKFLOW_STEP,
  WORKFLOW_STEP_STATUS_LABEL as CUSTOM_WORKFLOW_STEP_LABELS,
} from 'constants/all';

import { QuoteWorkflowStep, SelectorOption } from '../data/types';

const CUSTOM_WORKFLOW_STEPS = [
  CUSTOM_WORKFLOW_STEP.NOT_STARTED,
  CUSTOM_WORKFLOW_STEP.IN_PROGRESS,
  CUSTOM_WORKFLOW_STEP.ON_HOLD,
  CUSTOM_WORKFLOW_STEP.COMPLETED,
];

const WorkflowStepSelectsGroup = ({
  setValuesDict,
  valuesDict,
  workflowSteps,
}: {
  valuesDict: Record<string, SelectorOption>;
  setValuesDict: React.Dispatch<
    React.SetStateAction<Record<string, SelectorOption>>
  >;
  workflowSteps: QuoteWorkflowStep[];
}) => {
  const customWorkflowSteps = CUSTOM_WORKFLOW_STEPS.map((status) => ({
    label: CUSTOM_WORKFLOW_STEP_LABELS[status],
    value: status,
  }));
  const notApplicableStep = [
    {
      label: CUSTOM_WORKFLOW_STEP_LABELS[CUSTOM_WORKFLOW_STEP.NOT_APPLICABLE],
      value: CUSTOM_WORKFLOW_STEP.NOT_APPLICABLE,
    },
  ];
  const customWorkflowStepOptions = [
    {
      options: customWorkflowSteps,
    },
    {
      options: notApplicableStep,
    },
  ];

  return (
    <VStack width="full" alignItems="flex-start" spacing={1.5}>
      <Heading size="lg">Custom Workflows</Heading>
      {workflowSteps.map((workflowStep) => (
        <FormControl key={workflowStep.step.id}>
          <FormLabel h="fit-content">{workflowStep.step.name}</FormLabel>
          <Select
            placeholder="Don't change"
            onChange={(status: SelectorOption) => {
              if (status) {
                setValuesDict({
                  ...valuesDict,
                  [workflowStep.step.id]: status,
                });
              } else {
                /* eslint-disable @typescript-eslint/no-unused-vars */
                const { [workflowStep.step.id]: _, ...rest } = valuesDict;
                setValuesDict(rest);
              }
            }}
            options={customWorkflowStepOptions}
            value={valuesDict[workflowStep.step.id]}
          />
        </FormControl>
      ))}
    </VStack>
  );
};

export default WorkflowStepSelectsGroup;
